import moment from 'moment';
import FileSaver from 'file-saver';
import {CalendarEvent, CalendarExporterAbstract} from './calendar-exporter.abstract';

export class CalendarExporterText extends CalendarExporterAbstract {
  constructor(private readonly extension: string) {
    super();
  }

  exportForProject(releaseDate: string, projectCode: string): void {
    const calendarEvent = this.getCalendarEventForProjectCode(releaseDate, projectCode);
    this.getCalendar(calendarEvent, this.extension);
  }

  exportForPublication(releaseDate: string, bibCode: string): void {
    const calendarEvent = this.getCalendarEventForBibCode(releaseDate, bibCode);
    this.getCalendar(calendarEvent, this.extension);
  }

  exportForObservation(releaseDate: string, datasetId: string): void {
    const calendarEvent = this.getCalendarEventForObservation(releaseDate, datasetId);
    this.getCalendar(calendarEvent, this.extension);
  }

  private getCalendar(calendarEvent: CalendarEvent, extension: string): void {
    const event = ` BEGIN:VCALENDAR
                        VERSION:2.0
                        PRODID:-//ALMA Science Archive//NONSGML v1.0//EN
                        BEGIN:VEVENT
                        DTSTAMP:${moment().format(this.DATE_FORMAT_URL)}
                        SUMMARY;LANGUAGE=en-us:${decodeURIComponent(calendarEvent.title)}
                        DTSTART;VALUE=DATE:${calendarEvent.start}
                        DTEND;VALUE=DATE:${calendarEvent.end}
                        LOCATION:${decodeURIComponent(calendarEvent.location)}
                        DESCRIPTION:${decodeURIComponent(calendarEvent.retrieveMarkup)}
                        URL:${decodeURIComponent(calendarEvent.url)}
                        BEGIN:VALARM
                        TRIGGER:PT5M
                        ACTION:DISPLAY
                        DESCRIPTION:${decodeURIComponent(calendarEvent.description)}
                        END:VALARM
                        END:VEVENT
                        END:VCALENDAR`;

    const blob = new Blob([event], {type: 'text/plain'});
    (FileSaver as any).saveAs(blob, `caledar.${extension}`);
  }
}
